module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "easy-week-wrapper card"
  }, _vm._l((_vm.vehicles), function(data, plate) {
    return _c('EasyWeeks', {
      key: plate,
      attrs: {
        "shifts": data.shifts,
        "reservations": data.reservations,
        "plate": plate,
        "daysToShow": _vm.daysToShow
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-05e341ad!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/EasyWeeksWrapper.vue
// module id = 2234
// module chunks = 1